import { AccordionCard } from '../../common/AccordionCard';
import './FAQs.scss';

export const FAQs = ({ title = 'Frequently asked questions', faqs = [], styleObj = {} }) => {
  console.log(styleObj, 'styleObj')
  return (
    <div className="faq-wrapper" style={styleObj}>
      {title && <h2 className="faq-title mb-4">{title}</h2>}
      {faqs.length > 0 &&
        faqs.map(({ id, question, answer }) => (
          <AccordionCard key={id} id={id} title={question} description={answer} />
        ))}
      {faqs.length === 0 && <div>No FAQs are available.</div>}
    </div>
  );
};
